import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { AthletePackageHold, AthletePackageHoldWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCreateAthletePackageHold(): UseMutationResult<
  AxiosResponse<AthletePackageHold>,
  AxiosError<ErrorMessage>,
  AthletePackageHoldWrite
> {
  const queryClient = useQueryClient();

  const createAthletePackageHold = (
    athletePackageHold: AthletePackageHoldWrite,
  ): Promise<AxiosResponse<AthletePackageHold>> => {
    return client.post('athlete-package-holds/', athletePackageHold);
  };

  return useMutation(createAthletePackageHold, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athletePackages'],
      });
      queryClient.invalidateQueries({
        queryKey: ['invoices'],
      });
      queryClient.invalidateQueries({
        queryKey: ['athleteEvents'],
      });
    },
  });
}
